<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow class="align-items-center  my-1">
                <div class="col-12">
                    <p style="font-weight: bold; font-size: 16px; background: -webkit-linear-gradient(186deg, rgb(255, 167, 0) 40%, rgb(255, 123, 0) 100%) text; -webkit-text-fill-color: transparent; margin-bottom: 0;">
                        {{this.getLanguage['DB']['DL']}}
                    </p>
                </div>
                <div class="col-12 d-flex ">
                    <div class="quicklink position-relative">
                        <a href="javascript:void(0)" :class="isShowDetails ? 'active' : ''" @click="isShowForm = false;isShowPL =false;isShowDetails=true;getDownlineListing()">
                            {{getLanguage['GL']['D']}} <sup v-if="arr_reportList.length > 0">{{arr_reportList.length}}</sup>
                        </a>
                        <a href="javascript:void(0)" :class="isShowPL ? 'active' : ''" @click="isShowForm = false;isShowPL =true;isShowDetails=false;getDownlineProfitLossList()">
                            {{getLanguage['SMB']['RS3']}} <sup v-if="arr_profitLossList.length > 0">{{(arr_profitLossList.length) - 1}} </sup>
                        </a>
                        <a href="javascript:void(0)" :class="isShowForm ? 'active' : ''" @click="isShowForm = true;isShowPL =false;isShowDetails=false;getParentPrefixCode()">
                            + {{getLanguage['DB']['DL']}}
                        </a>
                        <img class="img-fluid float-right" v-if="isShowDetails" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_earth-19.svg" width="20" style="position: absolute; right: 0; top: 50%; transform: translate(0%, -50%); " @click="slideinDSearchfilter ? slideinDSearchfilter = false:slideinDSearchfilter = true">
                        <img class="img-fluid float-right" v-if="isShowPL" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_earth-19.svg" width="20" style="position: absolute; right: 0; top: 50%; transform: translate(0%, -50%); " @click="slideinPLSearchfilter ? slideinPLSearchfilter = false:slideinPLSearchfilter = true">
                    </div>
                </div>
            </CRow>

            <template v-if="isShowDetails">
                <CRow>
                    <CCol col="12">
                        <div class="record-header">
                            <div class="" @click="setSortTable2('GN')">
                                {{this.getLanguage['AG']['UDN']}} <!--/  {{getLanguage['AG']['PC']}}-->
                                <i :class="setSortLogo2('GN')" class="sortlogo"></i>
                            </div>
                            <div class="text-right">
                                {{this.getLanguage['DB']['DL']}} PT
                            </div>
                        </div>
                        <div class="nodata-record" v-if="arr_reportList.length == 0">
                            <div>
                                <img class="img-fluid" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_norecord.svg" width="125">
                                <span class="d-block" style="margin-top: -17px;"> {{this.getLanguage['GL']['NR']}}</span>
                            </div>
                        </div>
                        <div class="record-item" v-for="(data,index) in arr_reportList" @click="editGroup(data)">
                            <div>
                                <div class="text-white" style="display: flex; gap: 5px; align-items: start; ">
                                    {{data.GN}}
                                    <i class="fas fa-user theme-agent" v-if="data.AL==0"></i>
                                    <i class=" " v-else :class="[data.IOL?'fa-solid fa-house theme-outlet':'fas fa-users theme-subagent']"></i>
                                    <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']" :style="{ paddingTop: '0px' }">{{ data.AL.toString() }}</span>
                                </div>
                                <!--<div class="record-desc">
                                    {{ data.PC }}
                                </div>-->
                            </div>

                            <div class="text-right">
                                <div class="">{{ data.SAGPT }}%</div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </template>
            <template v-if="isShowPL">
                <CRow>
                    <CCol col="12">
                        <div class="record-header" style="grid-template-columns: auto 100px 100px ">
                            <div class="" @click="setSortTable('AGN')">
                                {{this.getLanguage['AG']['UDN']}}
                                <i :class="setSortLogo('AGN')" class="sortlogo"></i>
                            </div>
                            <div class="text-right" @click="setSortTable('TA')">
                                {{getLanguage['BETRPT']['TRO']}}
                                <i :class="setSortLogo('TA')" class="sortlogo"></i>
                            </div>
                            <div class="text-right" @click="setSortTable('WLA')">
                                {{getLanguage['PM']['GWL']}}
                                <i :class="setSortLogo('WLA')" class="sortlogo"></i>
                            </div>
                        </div>

                        <div class="nodata-record" v-if="(arr_profitLossList.length == 0 && arr_mainProfitLossList.length == 0) || (arr_profitLossList.length == 1 && arr_profitLossList[0].AGI == searchSubAgent)">
                            <div>
                                <img class="img-fluid" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_norecord.svg" width="125">
                                <span class="d-block" style="margin-top: -17px;"> {{this.getLanguage['GL']['NR']}}</span>
                            </div>
                        </div>
                        <div class="record-item" v-for="(data,index) in arr_profitLossList" style=" grid-template-columns: auto 100px 100px " v-if="searchSubAgent ? (data.AGI != searchSubAgent) :  (data.AGI != getUserInfo.AGI)">
                            <div>
                                <div class="text-white" style="display: flex; gap: 5px; align-items: start; ">
                                    {{data.AGN}}
                                    <i class="fas fa-user theme-agent" v-if="data.AL==0"></i>
                                    <i class=" " v-else :class="[data.IOL?'fa-solid fa-house theme-outlet':'fas fa-users theme-subagent']"></i>
                                    <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']" :style="{ paddingTop: '0px' }">{{ data.AL.toString() }}</span>
                                    <span v-if="data.AGI == getUserInfo.AGI"> (Own)</span>
                                </div>
                                <!--<div class="record-desc">
                                    {{ data.PC }}
                                </div>-->
                            </div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(data.TA)">{{ formatNumber(data.TA, 2, data.ISOC) }}</span>
                            </div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(data.WLA)">{{ formatNumber(data.WLA, 2, data.ISOC) }}</span>
                            </div>
                        </div>
                        <div class="record-item" v-if="arr_mainProfitLossList.length > 0 && (arr_profitLossList.length == 1 && arr_profitLossList[0].AGI != searchSubAgent)" style=" color: #fff; height: 55px; position: relative; gap: 5px; display: grid; grid-template-columns: auto 100px 100px ">
                            <div class="font-weight-bold" style="color:#fba506">{{this.getLanguage['DCSR']['T']}}</div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(arr_mainProfitLossList[0].TA) ">{{ formatNumber(arr_mainProfitLossList[0].TA, 2, arr_mainProfitLossList[0].ISOC) }}</span>
                            </div>
                            <div class="text-right">
                                <span class="font-weight-bold" :style="changeNegativecolor(arr_mainProfitLossList[0].WLA)">{{ formatNumber(arr_mainProfitLossList[0].WLA, 2, arr_mainProfitLossList[0].ISOC) }}</span>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </template>
            <template v-if="isShowForm">
                <div class="inputform">
                    <div class="form-section mt-0 ">
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage['AG']['PC']}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput size="sm"
                                        vertical
                                        v-model="subPC"
                                        :placeholder="this.getLanguage['AG']['PC']"
                                        :value="subPC"
                                        @change="v => subPC = v"
                                        maxlength="4"
                                        ref="subPC">
                                    <template #prepend>
                                        <CButton size="sm"
                                                 type="button"
                                                 color="primary"
                                                 style="min-width: auto; z-index: 0;">
                                            {{parentPC}}
                                        </CButton>
                                    </template>
                                </CInput>
                                <span class="ErrMsg">{{ ValidationGroupErrMsg('PC') }}{{this.str_prefixError}}{{this.str_prefixCorrect}}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage['AG']['UDN']}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput size="sm"
                                        vertical
                                        v-model="obj_Group.GN"
                                        :placeholder="this.getLanguage['AG']['UDN']"
                                        :value="obj_Group.GN"
                                        @change="v => obj_Group.GN = v"
                                        ref="GN">
                                </CInput>
                                <span class="ErrMsg">{{ ValidationGroupErrMsg('GN', 'UDN')}}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage['AG']['UU']}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput size="sm"
                                        vertical
                                        v-model="obj_Group.Agent.U"
                                        :placeholder="this.getLanguage['AG']['UU']"
                                        :value="obj_Group.Agent.U"
                                        @change="v => obj_Group.Agent.U = v"
                                        ref="Agent.U">
                                </CInput>
                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.U', 'UU') }}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage['AG']['UUP']}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput :type="isShowGeneratePassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['MEM']['UP']" v-model="obj_Group.Agent.UP" autocomplete="new-password">
                                    <template #append>
                                        <CButton size="sm"
                                                 type="button"
                                                 color="primary"
                                                 @click="isShowGeneratePassword = !isShowGeneratePassword"
                                                 style=" min-width: 40px; z-index: 0; background: #25282d !important; border: none !important;">
                                            <i class="fa fa-eye" v-if="isShowGeneratePassword"></i>
                                            <i class="fa fa-eye-slash" v-else></i>
                                        </CButton>
                                    </template>
                                </CInput>
                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.UP', 'UUP') }}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage['MEM']['CI']}}<span class="required" /></div>
                            <div class="sliding-item-desc">
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="obj_Group.DCI"
                                            disabled
                                            ref="DCI" />
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage['SAPS']['TYP']}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <treeselect :multiple="false"
                                            :options="constSubAgentType"
                                            :defaultExpandLevel="Infinity"
                                            :clearable="false"
                                            :placeholder="this.utilGetDDLanguage('SAPS.TYP')"
                                            v-model="obj_Group.SubAgentPayoutScheme.WLT"
                                            disabled
                                            :max-height="250"
                                            @change="v => obj_Group.SubAgentPayoutScheme.WLT = v">
                                    <div slot="value-label" slot-scope="{ node }">{{ utilGetErrorLanguage('SAPS.' + node.label) }}</div>
                                    <label slot="option-label" slot-scope="{ node }">
                                        {{ utilGetErrorLanguage('SAPS.' + node.label) }}
                                    </label>
                                </treeselect>
                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SubAgentPayoutScheme.POT', 'TYP') }}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage["SAPS"]["PT"]}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput size="sm"
                                        vertical
                                        type="number"
                                        v-model="obj_Group.SubAgentPayoutScheme.PT"
                                        :placeholder="this.getLanguage['SAPS']['PT']"
                                        :value="obj_Group.SubAgentPayoutScheme.PT"
                                        @change="v => obj_Group.SubAgentPayoutScheme.PT = v">
                                </CInput>
                                <span class="float-right label-tooltip">{{ formatNumber(selectedMinPT, 2, '') }} - {{ formatNumber(selectedMaxPT, 2, '') }}</span>
                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SubAgentPayoutScheme.PT','PT') }}</span>
                            </div>
                        </div>

                        <CTabs variant="tabs" id="contactTab" class="mt-2">
                            <!-- Finance Contact Tab -->
                            <CTab :title="getLanguage['SUB']['FC']" :active="blnFCOC === false ? true: false">
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['GAME']['NM']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['GAME']['NM']"
                                                size="sm"
                                                :value="obj_Group.Contact[0].CN"
                                                @change="v => obj_Group.Contact[0].CN = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['AG']['UPN']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['AG']['UPN']"
                                                size="sm"
                                                :value="obj_Group.Contact[0].PN"
                                                @change="v => obj_Group.Contact[0].PN = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['MEM']['TGID']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['MEM']['TGID']"
                                                size="sm"
                                                :value="obj_Group.Contact[0].T"
                                                @change="v => obj_Group.Contact[0].T = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['SUB']['SKYPE']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['SUB']['SKYPE']"
                                                size="sm"
                                                :value="obj_Group.Contact[0].S"
                                                @change="v => obj_Group.Contact[0].S = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['AG']['UE']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['AG']['UE']"
                                                size="sm"
                                                :value="obj_Group.Contact[0].E"
                                                @change="v => obj_Group.Contact[0].E = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['SUB']['OTHCT']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['SUB']['OTHCT']"
                                                size="sm"
                                                :value="obj_Group.Contact[0].OC"
                                                @change="v => obj_Group.Contact[0].OC = v"></CInput>
                                    </div>
                                </div>
                            </CTab>

                            <!-- Operation Contact Tab -->
                            <CTab :title="getLanguage['SUB']['OC']" :active="blnFCOC === true ? true: false">
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['GAME']['NM']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['GAME']['NM']"
                                                size="sm"
                                                :value="obj_Group.Contact[1].CN"
                                                @change="v => obj_Group.Contact[1].CN = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['AG']['UPN']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['AG']['UPN']"
                                                size="sm"
                                                :value="obj_Group.Contact[1].PN"
                                                @change="v => obj_Group.Contact[1].PN = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['MEM']['TGID']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['MEM']['TGID']"
                                                size="sm"
                                                :value="obj_Group.Contact[1].T"
                                                @change="v => obj_Group.Contact[1].T = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['SUB']['SKYPE']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['SUB']['SKYPE']"
                                                size="sm"
                                                :value="obj_Group.Contact[1].S"
                                                @change="v => obj_Group.Contact[1].S = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['AG']['UE']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['AG']['UE']"
                                                size="sm"
                                                :value="obj_Group.Contact[1].E"
                                                @change="v => obj_Group.Contact[1].E = v"></CInput>
                                    </div>
                                </div>
                                <div class="sliding-item">
                                    <div class="sliding-item-title">{{this.getLanguage['SUB']['OTHCT']}}</div>
                                    <div class="sliding-item-desc">
                                        <CInput :placeholder="getLanguage['SUB']['OTHCT']"
                                                size="sm"
                                                :value="obj_Group.Contact[1].OC"
                                                @change="v => obj_Group.Contact[1].OC = v"></CInput>
                                    </div>
                                </div>
                            </CTab>
                        </CTabs>

                        <CButton block color="success" class='font-weight-bold m-0 mb-5' @shortkey="saveGroup()" @click="saveGroup()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                    </div>
                </div>
            </template>

            <div :class="slideinPLSearchfilter  || slideinSummary || slideinDSummary || slideinDInfo  || slideinDSearchfilter || slideinDetail? 'slideinoverlay': ''" @click="closeSlideIn"></div>
            <div class="sliding-div" :class="{ 'is-visible': slideinPLSearchfilter }" @click.stop style="height:85%">
                <div class="position-relative h-100 overflow-auto">
                    <div class="searchForm">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['DB']['DL']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            @input="selectSubAgentOptions" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--<div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                        <treeselect :key="dd_memberKey"
                                    :multiple="false"
                                    :async="true"
                                    :load-options="loadMemberOptions"
                                    :options="ddMemberList"
                                    :defaultOptions="ddDefaultMemberList"
                                    :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                    :disable-branch-nodes="true"
                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                    :placeholder="this.utilGetDDLanguage('MEM.U')"
                                    @input="selectMemberOptions"
                                    @deselect="deSelectMemberOptions"
                                    :cacheOptions="false"
                                    v-model="searchUserId" />
                    </div>-->
                            <!--<div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>-->
                        </div>
                        <div class="d-flex" style="gap:10px;width:100%;align-items:center;position:absolute;bottom:0">
                            <CButton class='btnReset font-weight-bold m-0' block color="secondary" style=" font-size: 14px !important;" @click="searchExcludeSubAgent = false;searchAgent = null;searchSubAgent = null;searchUsername = null;clearDateRangeFilter()"><span>{{this.getLanguage['BTN']['RS']}}</span></CButton>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="getDownlineProfitLossList()" class='searchBtn font-weight-bold m-0' block color="success" @click="getDownlineProfitLossList()" style=" font-size: 14px !important;"><span>{{this.getLanguage['GL']['CONFIRM']}}</span></CButton>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinSummary }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['DB']['DL']}} {{getLanguage['AG']['S']}}</h2>

                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UDN']}}</div>
                        <div class="sliding-item-desc">{{obj_Group.GN}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['PC']}}</div>
                        <div class="sliding-item-desc">{{obj_Group.PC}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UU']}} </div>
                        <div class="sliding-item-desc">{{obj_Group.Agent.U}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UUP']}} </div>
                        <div class="sliding-item-desc">{{obj_Group.Agent.UP}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['SAPS']['TYP']}} </div>
                        <div class="sliding-item-desc" v-if="obj_Group.SubAgentPayoutScheme.WLT == 1">{{this.getLanguage['SAPS']['SC1']}}</div>
                        <div class="sliding-item-desc" v-else>{{this.getLanguage['SAPS']['SC2']}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage["SAPS"]["PT"]}} </div>
                        <div class="sliding-item-desc">{{obj_Group.SubAgentPayoutScheme.PT}}%</div>
                    </div>

                    <CRow class="recruit mt-3">
                        <CCol col="12">
                            <div class="custom-carousel"
                                 @touchstart="handleTouchStart"
                                 @touchmove="handleTouchMove"
                                 @touchend="handleTouchEnd">
                                <!--<ol class="carousel-indicators">
                            <li :class="{ active: index === currentSlide }" v-for="(slide, index) in 2"></li>
                        </ol>-->
                                <div class="carousel-inner text-center">
                                    <div v-for="(slide, index) in 2"
                                         :key="index"
                                         class="carousel-item"
                                         :class="{ active: index === currentSlide }">
                                        <div class="slide-content w-100" v-if="index == 0" :key="0">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                                <div class="mb-3 px-0" @click="copyDownlineLink()">
                                                    <div class="copyLink-icon m-auto d-flex justify-content-center align-items-center text-white"><i class="fa-solid fa-link" aria-hidden="true"></i></div>
                                                    <small class="text-white">{{getLanguage['BTN']['C']}}</small>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://t.me/share/?url='+ message" target="_blank">
                                                        <div class="telegram-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-telegram" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT2']}}</small>
                                                    </a>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://wa.me/?text='+ message " target="_blank">
                                                        <div class="whatsapp-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-whatsapp" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT1']}}</small>
                                                    </a>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://line.me/R/share?text='+ message" target="_blank">
                                                        <div class="line-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-line" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT5']}}</small>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <!--<div class="slide-content w-100" v-if="index == 1" :key="1">
                                    <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                    </div>
                                </div>-->
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                    <div class="slidlingbtn">
                        <CButton color="success" block @click="closeSummary()">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div " :class="{ 'is-visible': slideinDetail }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['DB']['DL']}} {{getLanguage['GL']['D']}}</h2>

                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UDN']}}</div>
                        <div class="sliding-item-desc">{{obj_Group.GN}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['PC']}}</div>
                        <div class="sliding-item-desc">{{obj_Group.PC}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{ this.getLanguage["MTA"]["TM1"] }}</div>
                        <div class="sliding-item-desc">{{ formatNumber(obj_Group.CDBL, 2, obj_Group.CS) }}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['SAPS']['TYP']}} </div>
                        <div class="sliding-item-desc" v-if="obj_Group.SubAgentPayoutScheme.WLT == 1">{{this.getLanguage['SAPS']['SC1']}}</div>
                        <div class="sliding-item-desc" v-else>{{this.getLanguage['SAPS']['SC2']}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage["SAPS"]["PT"]}} </div>
                        <div class="sliding-item-desc">{{obj_Group.SAGPT}}%</div>
                    </div>

                    <div style="margin-bottom:10px;" v-if="manageUserId > 0">
                        <div class="" style="gap: 5px; grid-template-columns: repeat(4, 1fr); display: grid;">
                            <div class="member-list-same custom-tooltip mt-1" @click='editData(manageUserId, obj_Group.PC, obj_Group.GN, obj_Group.SubAgentPayoutScheme)'>
                                <i class="cil-color-border"></i> <!--here Edit -->
                            </div>
                        </div>
                    </div>

                    <div class="slidlingbtn">
                        <CButton color="success" block @click="slideinDetail = false">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinDSearchfilter }" @click.stop style="height:85%">
                <div class="position-relative h-100 overflow-auto">
                    <div class="searchForm">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['DB']['DL']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions2"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList2"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            openDirection="below" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["T"]}} :</span>
                                <CInput size="sm" v-model="arr_FV['AL']"></CInput>
                            </div>
                        </div>

                        <div class="d-flex" style="gap:10px;width:100%;align-items:center;position:absolute;bottom:0">
                            <CButton class='btnReset font-weight-bold m-0' block color="secondary" style=" font-size: 14px !important;" @click="arr_FV['SAGAGI'] = null;arr_FV['AL'] = null;"><span>{{this.getLanguage['BTN']['RS']}}</span></CButton>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="getDownlineListing()" class='searchBtn font-weight-bold m-0' block color="success" @click="getDownlineListing()" style=" font-size: 14px !important;"><span>{{this.getLanguage['GL']['CONFIRM']}}</span></CButton>
                        </div>
                    </div>
                </div>
            </div>

            <div class="sliding-div" :class="{ 'is-visible': slideinDInfo }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage["AG"]["EDL"]}}</h2>
                    <form>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{this.getLanguage["AG"]["UDN"]}}</div>
                            <div class="sliding-item-desc">
                                <CInput :placeholder="getLanguage['AG']['UDN']"
                                        size="sm"
                                        :value="obj_data.GN"
                                        @change="v => obj_data.GN = v"
                                        :disabled="obj_data.I > 0"
                                        ref="U" autocomplete="username"></CInput>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['AG']['UUP']}} <span class="required" /></div>
                            <div class="sliding-item-desc">
                                <CInput :type="isShowPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['AG']['UUP']" v-model="obj_data.UP" autocomplete="new-password">
                                    <template #append>
                                        <CButton size="sm"
                                                 type="button"
                                                 color="primary"
                                                 @click="isShowPassword = !isShowPassword"
                                                 style=" min-width: 40px; z-index: 0; background: #fff !important; border: none !important;color:#000 !important">
                                            <i class="fa fa-eye" v-if="isShowPassword"></i>
                                            <i class="fa fa-eye-slash" v-else></i>
                                        </CButton>
                                    </template>
                                </CInput>
                                <span class="ErrMsg">{{ ValidationErrMsg('UP', 'UUP') }}</span>
                            </div>
                        </div>
                        <div class="sliding-item">
                            <div class="sliding-item-title">{{getLanguage['AG']['UCUP']}}<span class="required" /> </div>
                            <div class="sliding-item-desc">
                                <CInput :type="isShowConfirmPassword ? 'text' : 'password'" size="sm" :placeholder="getLanguage['AG']['UCUP']" v-model="obj_data.CUP" autocomplete="confirm-password">
                                    <template #append>
                                        <CButton size="sm"
                                                 type="button"
                                                 color="primary"
                                                 @click="isShowConfirmPassword = !isShowConfirmPassword"
                                                 style=" min-width: 40px; z-index: 0; background: #fff !important; border: none !important; color: #000 !important">
                                            <i class="fa fa-eye" v-if="isShowConfirmPassword"></i>
                                            <i class="fa fa-eye-slash" v-else></i>
                                        </CButton>
                                    </template>
                                </CInput>
                                <span class="ErrMsg">{{ ValidationErrMsg('CUP', 'UCUP') }}</span>
                            </div>
                        </div>
                    </form>

                    <div class="btngroup">
                        <CButton block color="secondary" class='font-weight-bold m-0' @click="slideinDInfo = false;"><span>{{this.getLanguage['BTN']['CLO']}}</span></CButton>
                        <CButton block color="success" class='font-weight-bold m-0' @shortkey="saveData()" @click="saveData()"><span>{{this.getLanguage['BTN']['SV']}}</span></CButton>
                    </div>
                </div>
            </div>

            <div class="sliding-div " :class="{ 'is-visible': slideinDSummary }" @click.stop>
                <div class="position-relative h-100 overflow-auto">
                    <h2 class="text-white font-weight-bold">{{this.getLanguage['DB']['DL']}} {{getLanguage['AG']['S']}}</h2>

                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UDN']}}</div>
                        <div class="sliding-item-desc">{{obj_data.GN}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['PC']}}</div>
                        <div class="sliding-item-desc">{{obj_data.PC}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UU']}} </div>
                        <div class="sliding-item-desc">{{obj_data.U}}</div>
                    </div>
                    <div class="sliding-item">
                        <div class="sliding-item-title">{{this.getLanguage['AG']['UUP']}} </div>
                        <div class="sliding-item-desc">{{obj_data.UP}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_data && obj_data.SubAgentPayoutScheme">
                        <div class="sliding-item-title">{{this.getLanguage['SAPS']['TYP']}} </div>
                        <div class="sliding-item-desc" v-if="obj_data.SubAgentPayoutScheme.WLT == 1">{{this.getLanguage['SAPS']['SC1']}}</div>
                        <div class="sliding-item-desc" v-else>{{this.getLanguage['SAPS']['SC2']}}</div>
                    </div>
                    <div class="sliding-item" v-if="obj_data && obj_data.SubAgentPayoutScheme">
                        <div class="sliding-item-title">{{this.getLanguage["SAPS"]["PT"]}} </div>
                        <div class="sliding-item-desc">{{obj_data.SubAgentPayoutScheme.PT}}%</div>
                    </div>

                    <CRow class="recruit mt-3">
                        <CCol col="12">
                            <div class="custom-carousel"
                                 @touchstart="handleTouchStart"
                                 @touchmove="handleTouchMove"
                                 @touchend="handleTouchEnd">
                                <!--<ol class="carousel-indicators">
                    <li :class="{ active: index === currentSlide }" v-for="(slide, index) in 2"></li>
                </ol>-->
                                <div class="carousel-inner text-center">
                                    <div v-for="(slide, index) in 2"
                                         :key="index"
                                         class="carousel-item"
                                         :class="{ active: index === currentSlide }">
                                        <div class="slide-content w-100" v-if="index == 0" :key="0">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                                <div class="mb-3 px-0" @click="copyDownlineLink()">
                                                    <div class="copyLink-icon m-auto d-flex justify-content-center align-items-center text-white"><i class="fa-solid fa-link" aria-hidden="true"></i></div>
                                                    <small class="text-white">{{getLanguage['BTN']['C']}}</small>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://t.me/share/?url='+ message" target="_blank">
                                                        <div class="telegram-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-telegram" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT2']}}</small>
                                                    </a>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://wa.me/?text='+ message " target="_blank">
                                                        <div class="whatsapp-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-whatsapp" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT1']}}</small>
                                                    </a>
                                                </div>
                                                <div class="mb-3 px-0">
                                                    <a class="text-white" :href="'https://line.me/R/share?text='+ message" target="_blank">
                                                        <div class="line-icon m-auto d-flex justify-content-center align-items-center"><i class="fa-brands fa-line" aria-hidden="true"></i></div>
                                                        <small>{{getLanguage['CU']['PT5']}}</small>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="slide-content w-100" v-if="index == 1" :key="1">
                                            <div className="" style="width: 100%; display: grid; grid-template-columns: repeat(5, 1fr); gap: 15px;">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                    <div class="slidlingbtn">
                        <CButton color="success" block @click="closeSlideIn()">
                            {{this.getLanguage["BTN"]["CLO"]}}
                        </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, consMetaRobot, constImgURClientId, loadingFullScreen, constSubAgentType, constSubAgentSchemeType } from '@/modules/Constant.js'
    import $ from 'jquery'
    import { required, requiredIf, minLength, maxLength, alphaNum, decimal, email, sameAs, numeric, minValue  } from 'vuelidate/lib/validators'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                // Pagination and Counters
                int_RC: 200,
                int_Total: 0,
                int_Page: 1,
                int_IC: 1,
                int_TP: 0,

                // UI State
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                slideinPLSearchfilter: false,
                slideinSummary: false,
                slideinDSummary : false,
                slideinDInfo : false,
                slideinDSearchfilter : false,
                slideinDetail : false,
                isShowDetails: true,
                isShowPL: false,
                isShowForm: false,

                //profit loss
                ddAgentList: null,
                ddSubAgentList: null,
                ddSubAgentList2: null,
                ddDefaultSubBrand: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                ddCurrencyList: null,
                dd_memberKey: 0,
                searchAgi: '',
                searchAgent: null,
                searchSubAgent: null,
                searchUserId: null,
                searchUsername: null,
                searchCurrency: null,
                searchCurrencyFilter: null,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                arr_mainProfitLossList: [],
                arr_profitLossList: [],
                arr_breadcrum: [],
                constAccessType: constAccessType,
                str_tableSortBy: "TA", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending,
             
                ML_D: false,
                rtSubBrand: 0,
                hideBrand: false,
          
                //downline details
                obj_Group: {
                    "I": 0,
                    "RS": 2,        //Status
                    "GN": "",       //Brand Name
                    "AT": "",       //Agent Type
                    "PGI": "",      //Parent Group Id
                    "PGIT": null,   //3-0304
                    "PC": "",       //Prefix Code
                    "WLIPS": "",    //White List Ip
                    "SPG": "",      //Sub Brand
                    "IOL": false,      //Outlet
                    //"SAPSI": null,
                    //"L": "",
                    //"Language": null,
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "Contact": [{
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    },
                    {
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    }],
                    "SubAgentPayoutScheme": {
                        "PT": 0,
                        "WLT": 1,
                        "POT": 1
                    },
                    "SubAgentCustomPT": [],
                    "WhiteListIP": [],

                    //No required for Sub-Agent
                    //"PT": "0.0",
                    "DPT": "0.0",
                    "DCI": null,
                    "TB": "0.0",
                    "TCB": "0.00",
                    "CI": "",
                    "CurrencyIds": [],
                    "L": "",
                    "Language": [],
                    "GPI": "",
                    "GameProviderIds": [],
                    "LB": "0",
                    "ACT": "0",
                    "H2PU": "",
                    "H2PMC": "",
                    "H2PSC": "",
                    "H2PCC": "",
                    "OOPTHMN": "",
                    "OOPTHAS": "",
                    "OOPTHSK": "",
                    "OOPVIMN": "",
                    "OOPVIAS": "",
                    "OOPVISK": "",
                    "EZPIDRMN": "",
                    "EZPIDRAS": "",
                    "EZPMYRMN": "",
                    "EZPMYRAS": "",
                    "EZPTHBMN": "",
                    "EZPTHBAS": "",
                    "EZPVNDMN": "",
                    "EZPVNDAS": "",
                    "TUPVNDMN": "",
                    "TUPVNDAS": "",
                    "TUPMYRMN": "",
                    "TUPMYRAS": "",
                    "XFTHN": "",
                    "XFTHK": "",
                    "XFVIN": "",
                    "XFVIK": "",
                    "XFMYRN": "",
                    "XFMYRK": "",
                    "XFUSDTN": "",
                    "XFUSDTK": "",
                    "XFIDRN": "",
                    "XFIDRK": "",
                    "H2PCurrencyCodes": null,
                    "SAGAGI": null,
                    "CA": 0,
                    "IGGE": 1,
                },
                currentSlide: 0,
                startX: 0,
                endX: 0,
                startTime: 0,
                threshold: 50, // Minimum distance to consider a swipe
                timeThreshold: 800,// Maximum time in milliseconds for a swipe
                isSwiping: false, // Track if a swipe is in progress
                isShowGeneratePassword: true,
                message: null,
                loginurl: null,
                str_prefixError: "",
                str_prefixCorrect: "",
                parentPC: "",
                subPC: "",
                //constSubAgentType: constSubAgentType,
                constSubAgentType: [
                    {
                        id: 1,
                        label: 'SC1'
                    },
                ],
                selectedMaxPT: 0,
                selectedMinPT: 0,
                blnFCOC: false,

                //downline profit loss
                str_tableSortBy2: "", //(sort the table col name)
                bool_isSort2: false, // Table Ascending Descending,
                arr_reportList: [],
                arr_FV: {
                    "GN": "",
                    "PC": "",
                    "L": [],
                    "AL": "",
                    "AGI": null,
                    "SAGAGI": null,
                    "DR": {
                        startDate: "",
                        endDate: ""
                    },
                }, //Filter Value
                dd_agentgroupFilter: [],
                manageUserId: 0,
                obj_data: {
                    I: 0,
                    RS: 2,
                    U: "",
                    UP: "",
                    CUP: "",
                    DN: "",
                    E: "",
                    PN: "",
                    RI: null,
                    AGI: 0,
                    PC: "",
                    ATAGI: null,
                    SAGAGI: null,
                    WLIPS: "",
                    WhiteListIP: [],
                    // WLIPList: [],
                    WLIPS_R: "",
                    LFC: 0,
                    ICS: true,
                    ALOD: 7,
                    E2FA: null
                },
                message: null,
                loginurl: null,
                bool_CV: false,
                bool_groupCV: false,
                isShowPassword: false,
                isShowConfirmPassword: false,

            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;

                            that.dependUrlShowItem();
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            dependUrlShowItem() {
                if (this.$route.query.t) {
                    this.isShowDetails = this.$route.query.t == 1 ? true : false;
                    this.isShowPL = this.$route.query.t == 2 ? true : false;
                    this.isShowForm = this.$route.query.t == 3 ? true : false;
                    if (this.isShowDetails) {
                        this.getDownlineListing();
                    } else if (this.isShowPL) {
                        this.getDownlineProfitLossList();
                    } else if (this.isShowForm) {
                        this.getParentPrefixCode();
                    }
                }
            },
            getCurrencyList(currencyCode = "") {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "" || currencyCode != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (currencyCode != "" && that.ddCurrencyList[i].label == currencyCode) {
                                            that.searchCurrencyFilter = that.ddCurrencyList[i].id;
                                        }
                                        else if (currencyCode == "" && that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                        }
                                        if (that.searchCurrency != null && that.searchCurrencyFilter != null) {
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }
                    });
            },
            getAgentGroupDropdown() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupFilter = that.deepClone(d.dropdownlist);

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                        }
                    });
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            ctrPage(newPage) {
                this.int_Page = newPage;
                if (newPage > this.int_TP) {
                    this.int_Page = this.int_TP;
                }
                if (newPage <= 0) {
                    //here set the limit of the label num
                    this.int_Page = 1;
                }
                this.int_IC = this.int_Page;
                this.getDownlineProfitLossList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            closeSlideIn() {
                this.slideinPLSearchfilter = false;
                this.slideinSummary = false;
                this.slideinDSummary = false;
                this.slideinDInfo = false;
                this.slideinDSearchfilter = false;
                this.slideinDetail = false;
                this.recruitDownline();
            },

            //slideinDSearchfilter
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    parentAGI = this.searchAgent.split("-")[1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },

            //slideinDSearchfilter
            loadSubBrandOptions2({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent2) {
                    parentAGI = this.searchAgent2.split("-")[1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList2 = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList2 = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList2 = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubAgentList2 = [];
                            }
                            callback(null, that.ddSubAgentList2);
                        });
                }
            },

            //downline profitloss
            selectSubAgentOptions(value, instanceId) {
                this.arr_breadcrum = [];
                this.searchAgi = 0;
                if (value) {
                    this.searchAgi = value;
                } else {
                    this.searchSubAgent = null;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getDownlineProfitLossList();
            },
            setSortLogo(str_TF) {
                return `${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'active cil-sort-descending' : 'active cil-sort-ascending') : 'fa fa-sort'}`;//here change the sort logo
            },
            //loadMemberOptions({ action, searchQuery, callback }) {
            //    var that = this;
            //    if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
            //        that.ddMemberList = null;
            //        callback(this.getLanguage['MEM']['PS3']);
            //    }
            //    else {
            //        searchQuery = encodeURIComponent(searchQuery);
            //        this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
            //            function (d, s) {
            //                if (s && d && d.dropdownlist) {
            //                    that.ddMemberList = d.dropdownlist;
            //                }
            //                else {
            //                    that.ddMemberList = [];
            //                }

            //                callback(null, that.ddMemberList);
            //            });
            //    }
            //},
            //selectMemberOptions(node, instanceId) {
            //    if (this.ddMemberList && this.ddMemberList.length > 0) {
            //        var index = -1;
            //        for (var i = 0; i < this.ddMemberList.length; i++) {
            //            if (this.ddMemberList[i].id == node) {
            //                this.searchUsername = this.ddMemberList[i].label;
            //                break;
            //            }
            //        }
            //    }
            //    else {
            //        this.searchUsername = null;
            //    }
            //},
            //deSelectMemberOptions(node, instanceId) {
            //    this.searchUserId = null;
            //    this.searchUsername = null;
            //},
            getDownlineProfitLossList() {
                var that = this;
                var path = "";
                this.arr_mainProfitLossList = [];
                this.arr_profitLossList = [];
                this.arr_breadcrum = [];

                //var path = '';
                var hasDefaultPath = false;
                path = this.getListingParamQuery(1, 100, this.str_tableSortBy, this.bool_isSort);
                if (path) {
                    hasDefaultPath = true;
                }

                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                    path += "&f.AGT=4";

                    // generate breadcrum link
                    this.getDataApi(`/api/dd/subagent-parent-hierachy/${this.searchSubAgent}`,
                        function (d, s) {
                            if (s) {
                                that.arr_breadcrum = d;
                            }
                            else {
                                that.arr_breadcrum = []
                            }
                        });
                }

                if (this.getUserInfo.CID) {
                    path += "&f.CI=" + this.getUserInfo.CID;
                }
                else if (localStorage.getItem('CCUSD') != "") {
                    path += "&f.CI=" + localStorage.getItem('CCUSD');
                }

                if (this.searchCreatedTS) {

                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }

                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.bool_fullLoading = true;

                this.getDataApi(`/api/reports/winloss/totalbsag?${path}`,
                    function (d, s) {
                        if (s) {
                            that.slideinPLSearchfilter = false;
                            if (d.R2) {
                                that.arr_mainProfitLossList = d.R2;
                            } else {
                                that.arr_mainProfitLossList = [];
                            }

                            if (d.R1 && d.R1.length > 0) {
                                var a = d.R1[0].AL;
                                for (var i = 0; i < d.R1.length; i++) {
                                    d.R1[i].AL -= a;
                                }
                                that.arr_profitLossList = d.R1;
                            } else {
                                that.arr_profitLossList = [];
                            }
                        }


                        that.bool_fullLoading = false;
                    });
                this.ML_D = this.checkModuleAccess('ML', 'M', constAccessType.delete);
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },

            //downline +
            closeSummary() {
                this.slideinSummary = false;
                this.bool_groupCV = false;
                this.recruitDownline();
            },
            saveGroup() {
                this.bool_fullLoading = true;

                this.obj_Group.I = 0;
/*                this.obj_Group.GN = this.parentPC + this.subPC;*/
                this.obj_Group.PC = this.parentPC + this.subPC;
                this.obj_Group.Agent.DN = this.obj_Group.GN;
                this.obj_Group.CurrencyIds = this.obj_Group.CI;
                this.obj_Group.Language = this.obj_Group.L;
                this.obj_Group.Agent.CUP = this.obj_Group.Agent.UP;
                this.obj_Group.SPG = this.curAGI;
                this.obj_Group.Agent.E = "";
                this.obj_Group.Agent.PN = "";
                this.obj_Group.SubAgentPayoutScheme.I = 0;
                this.obj_Group.Agent.RS = 2;
                this.obj_Group.CDBL = 0;
                this.obj_Group.IGGE = true;

                var a = this.selectedMaxPT - this.obj_Group.SubAgentPayoutScheme.PT

                for (var i = 0; i < this.arr_CustomProvider.length; i++) {
                    var b = this.arr_CustomProvider[i].MPT - a;
                    if (b < 0) {
                        b = 0;
                    }
                    this.arr_CustomProvider[i].PT = b;
                }

                if (this.obj_Group.PGIT != null && this.obj_Group.PGIT.length > 0) {
                    var agi = this.obj_Group.PGIT.split("-");
                    this.obj_Group.PGI = agi[1];
                    this.obj_Group.AT = 4;
                }

                this.obj_Group.WLIPS = "";
          
                //// check the require field
                this.obj_Group.SubAgentCustomPT = this.arr_CustomProvider;

                this.bool_groupCV = true;
                this.$v.obj_Group.$touch();
                if (!this.$v.obj_Group.$error) {
                    this.ValidatePrefixCode(true);
                } else {
                    this.bool_fullLoading = false;
                    //get the object for validating.
                    const validation = this.$v["obj_Group"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            saveGroupToServer() {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                var that = this;

                this.postDataApi(`/api/sag/s`, this.obj_Group,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.bool_isAMV = false;

                            that.$fire({
                                // type: 'error',
                                //title: that.utilGetErrorLanguage("ERR.SS"),
                                html: that.utilGetErrorLanguage("GL.AS"),
                                width: '20em',
                                keydownListenerCapture: true,
                                iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                customClass: {
                                    title: 'afb-alert-title text-success',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                },
                                didOpen: () => {
                                    const confirmButton = document.querySelector('.afb-alert-action button');
                                    if (confirmButton) {
                                        confirmButton.focus();
                                    }
                                }
                            });

                            that.message = that.loginurl + '?pc=' + that.obj_Group.PC + '%26uid=' + that.obj_Group.Agent.U + '%26p=' + that.obj_Group.Agent.UP + '%0A%0APrefixCode : ' + that.obj_Group.PC + '%0AUsername : ' + that.obj_Group.Agent.U + '%0APassword : ' + that.obj_Group.Agent.UP;
                            that.slideinSummary = true;
                        }
                    });
            },
            ValidatePrefixCode(callSave) {
                var that = this;
                var prefixCode = (this.obj_Group.PC).toUpperCase();
                this.str_prefixCorrect = '';
                this.pc_msg_class = 'ErrMsg';

                if (prefixCode.length == 8) {

                    this.getDataApi('/api/ag/chk/0/' + prefixCode,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (d.ERRC != "" && that.obj_Group.I == 0) {
                                //// prefix code duplicated
                                that.str_prefixError = String.format(that.utilGetErrorLanguage(d.ERRC), prefixCode);
                            }
                            else {
                                that.pc_msg_class = 'ValidMsg';
                                that.str_prefixError = "";
                                if (callSave) {
                                    that.obj_Group.PC = prefixCode;
                                    that.saveGroupToServer();
                                }
                            }
                        });
                }
                else {
                    that.str_prefixError = String.format(this.getLanguage["SUB"]['ERR8'], this.getLanguage["AG"]["PC"]);
                }
            },
            getParentPrefixCode() {
                this.bool_fullLoading = true;
                var agi = this.curAGI;
                var that = this;

                if (agi) {
                    this.getDataApi(`/api/sag/gb/${agi}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.parentPC = d.D;
                                that.recruitDownline();
                            }
                        });
                }
            },
            GeneratePrefixCode() {
                if (this.parentPC) {
                    var agi = this.parentPC;
                    var that = this;

                    this.getDataApi(`/api/sag/pc/${agi}/4`,
                        function (d, s) {
                            if (s) {
                                that.subPC = d.D;
                                that.obj_Group.PC = agi + d.D;
                                that.obj_Group.Agent.U = agi + d.D;
                            }
                        });
                }
            },
            GeneratePassword() {
                var that = this;

                this.getDataApi(`/api/sag/agp`,
                    function (d, s) {
                        if (s) {
                            that.obj_Group.Agent.UP = d.D;
                        }
                    });
            },
            ValidationGroupErrMsg(value, langKey = "") {
                if (value == "PC" && this.str_prefixError != "") {
                    return "";
                }

                if (this.bool_groupCV) {
                    var parent = "";

                    if (value.indexOf(".") >= 0) {
                        var tempKey = value.split('.');
                        parent = tempKey[0];
                        value = tempKey[1];
                    }

                    if (langKey == "") {
                        langKey = value;
                    }

                    var validateObj = parent == "" ? this.$v.obj_Group[value] : this.$v.obj_Group[parent][value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        if (parent == "SubAgentPayoutScheme") {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["SAPS"][langKey]);
                        } else {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                        }
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        return String.format(this.getLanguage["SUB"]['ERR8'], this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('SAPS.ERRBTW'), this.getLanguage["SAPS"][langKey], this.selectedMinPT, this.selectedMaxPT);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                }
                return "";
            },
            recruitDownline() {
                this.bool_fullLoading = true;
                var id = this.curAGI;
                var that = this;

                this.getDataApi(`/api/sag/g/${id}`,
                    function (d, s) {
                        if (s) {
                            that.obj_Group = Object.assign(that.obj_Group, d.D);
                            that.obj_Group.GN = "";
                            that.obj_Group.Agent = {
                                "I": -1,
                                "UP": "",
                                "CUP": ""
                            };
                            that.obj_Group.Contact = [{
                                "CN": "",
                                "PN": "",
                                "T": "",
                                "S": "",
                                "E": "",
                                "OC": ""
                            },
                            {
                                "CN": "",
                                "PN": "",
                                "T": "",
                                "S": "",
                                "E": "",
                                "OC": ""
                                }],
                            that.obj_Group.SubAgentPayoutScheme.WLT = 1;
                            that.obj_Group.SubAgentPayoutScheme.WLTN = "SC1";
                            that.GeneratePrefixCode();
                            that.GeneratePassword();

                            if (that.obj_Group.SPG != that.obj_Group.AAGI)
                                that.searchSubBrand = that.obj_Group.SPG;
                            else
                                that.searchSubBrand = null;
                            if (that.obj_Group.IOL == 1)
                                that.obj_Group.IOL = true;
                            else
                                that.obj_Group.IOL = false;

                            that.bool_groupCV = false;
                            that.getMaxPT();
                            that.bool_fullLoading = false;

                        }
                    });
            },
            getCustomPTProvider(agi = 0, isParent = 0) {
                var that = this;

                this.getDataApi(`/api/sag/gcpt/${agi}/${isParent}`,
                    function (d, s) {
                        if (s && d && d.D) {
                            that.arr_CustomProvider = d.D;
                            that.obj_Group.SubAgentCustomPT = d.D;

                        }
                        else {
                            that.arr_CustomProvider = [];
                        }
                    });
            },
            getMaxPT(agiChange = 0) {
                var that = this;
                var agi = this.curAGI;

                this.getCustomPTProvider(agi, 1);

                //Max General PT
                this.getDataApi(`/api/sag/g-maxpt/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.selectedMaxPT = d.D.MaxPT;
                            if (d.D.OEMI == 2) {
                                if (that.obj_Group.I == 0) {
                                    that.obj_Group.PC = d.D.PC;
                                    that.obj_Group.DCI = d.D.DCI;
                                    that.bool_houtLockSB = true;
                                    that.obj_Group.IOL = false;
                                    that.str_houtOriPrefix = d.D.PC;
                                }

                            } else {
                                that.bool_houtLockSB = false;
                                that.str_houtOriPrefix = "";
                            }

                        }
                    });
            },
            handleTouchStart(event) {
                this.startX = event.touches[0].clientX;
                this.startTime = Date.now(); // Record the start time
                this.isSwiping = false; // Reset swiping status
            },
            handleTouchMove(event) {
                this.endX = event.touches[0].clientX;

                // Determine if the user is swiping based on distance
                const distanceX = this.endX - this.startX;
                if (Math.abs(distanceX) > this.threshold) {
                    this.isSwiping = true; // Set swiping status to true if the swipe distance exceeds the threshold
                }
            },
            handleTouchEnd() {
                const distanceX = this.endX - this.startX;
                const elapsedTime = Date.now() - this.startTime;

                // Check if the swipe is valid
                if (this.isSwiping && elapsedTime < this.timeThreshold) {
                    // Only execute swipe actions if it's a valid swipe
                    if (distanceX > 0) {
                        this.nextSlide();
                    } else {
                        this.prevSlide();
                    }
                } else if (!this.isSwiping) {
                    // Treat it as a click if not swiping
                }

            },
            nextSlide() {
                this.currentSlide =
                    (this.currentSlide + 1) % 2;
            },
            prevSlide() {
                this.currentSlide =
                    (this.currentSlide - 1 + 2) %
                    2;
            },


            // downline details
            setSortTable2(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy2 = SV;
                this.bool_isSort2 = !this.bool_isSort2;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getDownlineListing();
            },
            setSortLogo2(str_TF) {
                return `${this.str_tableSortBy2 == str_TF ? (this.bool_isSort2 ? 'active cil-sort-descending' : 'active cil-sort-ascending') : 'fa fa-sort'}`;//here change the sort logo
            },
            getList(PC) {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(
                    1,
                    100,
                    this.str_tableSortBy2,
                    this.bool_isSort2
                );
                //search
                if (PC) {
                    if (path) {
                        path += "&";
                    }
                    path += (
                        "&f.PC=" + PC
                    );
                }

                this.getDataApi(`/api/agt/l?${path}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s && d.D.Items.length == 1) {
                        that.manageUserId = d.D.Items[0].I;
                        that.slideinDetail = true;
                    }
                });
            },
            getDownlineListing() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy2, this.bool_isSort2);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += "&f.PC=" + this.arr_FV["PC"];

                    if (this.arr_FV["AL"] > 0) {
                        path += "&f.AL=" + this.arr_FV["AL"]
                    }

                    if (this.arr_FV["SAGAGI"] != null) {
                        path += "&f.ATAGI=4-" + this.arr_FV["SAGAGI"]
                        //} else if (this.arr_FV["AGI"] != null) {
                        //    path += "&f.ATAGI=" + this.arr_FV["AGI"]
                    }

                    //if (this.arr_FV.DR.startDate != "") {
                    //    var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                    //    path += "&f.CTS_from=" + cts_from;
                    //}
                    //if (this.arr_FV.DR.endDate != "") {
                    //    var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                    //    path += "&f.CTS_to=" + cts_to;
                    //}

                }

                this.getDataApi(`/api/sag/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        that.slideinDSearchfilter = false;
                        if (s) {
                            that.int_TP = d.D.TotalPages;
                            //that.int_Total = d.D.TotalItems;
                            that.arr_reportList = d.D.Items;
                        }
                    });
            },
            editGroup(data) {
                var that = this;
                this.bool_CV = false;
                this.getList(data.PC);
                this.obj_Group = Object.assign(this.obj_Group, data);
            },
            editData(id, prefixCode, displayName, SubAgentPayoutScheme) {
                this.slideinDetail = false;
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/${id}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setData(d.D, prefixCode, displayName, SubAgentPayoutScheme);
                    }
                });
            },
            setData(data, prefixCode, displayName, SubAgentPayoutScheme) {
                data.UP = '';
                this.obj_data = data;
                this.obj_data.PC = prefixCode;
                this.obj_data.GN = displayName;
                this.obj_data.SubAgentPayoutScheme = SubAgentPayoutScheme;
                if (this.obj_data.AGI != 0) {
                    this.obj_data.ATAGI = this.obj_data.AT + '-' + this.obj_data.AGI;

                    if (this.obj_data.SAGAGI > 0) {
                        this.obj_data.ATAGI = '3-' + this.obj_data.AGI;
                        this.getSubAgentGroupDropdown(this.obj_data.SAGAGI, true)
                        this.SubAgentGroupChange(this.obj_data.SAGAGI)
                    } else {
                        this.AgentGroupChange(this.obj_data.ATAGI);
                    }
                }
                this.obj_data.WLIPS = "";
                this.obj_data.WLIPS_R = "";
                this.slideinDInfo = true;
            },
            getSubAgentGroupDropdown(value, isFirstLoad = false) {
                if ((isFirstLoad && this.getUserInfo.AT > 3) || !isFirstLoad || (isFirstLoad && value > 3)) {

                    var that = this;
                    this.getDataApi(`/api/dd/subbrand/0/0/${value}/1/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                if (isFirstLoad) {
                                    that.dd_DefaultSubBrandSearch = that.deepClone(d.dropdownlist);
                                    //that.arr_FV['SAGAGI'] = that.dd_DefaultSubBrandSearch[0].id;
                                    that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                }
                                else {
                                    that.dd_DefaultSubBrand = that.deepClone(d.dropdownlist);
                                    that.rtSubBrandEdit = that.rtSubBrandEdit == 0 ? 1 : 0;
                                }
                            }
                        });
                }
            },
            AgentGroupChange(value) {
                if (this.obj_data['I'] == 0) {
                    this.obj_data['DI'] = null;
                }
                var that = this;
                var agi = 0;
                this.obj_data['SAGAGI'] = null;
                var ri = that.obj_data.RI;
                //this.obj_data['RI'] = null;

                if (value != "") {
                    agi = value.split("-")[1];
                    that.obj_data.RI = null;
                    that.dd_role = [];
                }
                this.getDataApi(`/api/ag/g/${agi}`, function (d, s) {
                    if (s) {
                        that.obj_data.PC = d.D.PC;
                    }
                });

                this.getDataApi(`/api/dd/rll/${agi}`, function (d, s) {
                    if (s) {
                        that.dd_role = d.dropdownlist;
                        that.obj_data.RI = ri;
                    }
                });
                //that.sensBtn = ((that.isSENS == 1 && agi != that.curAGI) ? true : false);
            },
            SubAgentGroupChange(value) {
                if (this.obj_data['I'] == 0) {
                    this.obj_data['DI'] = null;
                }
                //this.obj_data['RI'] = null;
                var that = this;
                var agi = 0;
                if (value != "" && value != undefined) {
                    agi = value;
                    that.obj_data.RI = null;
                    that.dd_role = [];
                } else {
                    agi = that.obj_data.ATAGI.split("-")[1];
                    that.obj_data.RI = null;
                    that.dd_role = [];
                }
                this.getDataApi(`/api/ag/g/${agi}`, function (d, s) {
                    if (s) {
                        that.obj_data.PC = d.D.PC;
                    }
                });

                this.getDataApi(`/api/dd/rll/${agi}`, function (d, s) {
                    if (s) {
                        that.dd_role = d.dropdownlist;
                        if (that.dd_role.length == 1) {
                            that.obj_data.RI = that.dd_role[0].id;
                        }
                    }
                });
            },
            saveData() {
                //this.obj_data.I = 0;
                var disPlayName = this.obj_data.DN;
                this.obj_data.DN = disPlayName.trimLeft();
                var userName = this.obj_data.U;
                this.obj_data.U = userName.trimLeft();
                this.bool_CV = true;

                ////when save, if got subagentid assign it into agentid
                //if (this.obj_data.SAGAGI) {
                //    this.obj_data.ATAGI = "4-" + this.obj_data.SAGAGI;
                //}

                this.$v.obj_data.$touch();
                if (!this.$v.obj_data.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    this.postDataApi(`/api/agt/s`, this.obj_data, function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.slideinDInfo = false;
                            that.bool_CV = false;

                            that.$fire({
                                // type: 'error',
                                //title: that.utilGetErrorLanguage("ERR.SS"),
                                html: that.utilGetErrorLanguage("GL.AS"),
                                width: '20em',
                                keydownListenerCapture: true,
                                iconHtml: '<img src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/set3/ggeran_success-17.png" loading="lazy" width="125">',
                                customClass: {
                                    title: 'afb-alert-title text-success',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                },
                                didOpen: () => {
                                    const confirmButton = document.querySelector('.afb-alert-action button');
                                    if (confirmButton) {
                                        confirmButton.focus();
                                    }
                                }
                            });
                            that.message = that.loginurl + '?pc=' + that.obj_data.PC + '%26uid=' + that.obj_data.U + '%26p=' + that.obj_data.UP + '%0A%0APrefixCode : ' + that.obj_data.PC + '%0AUsername : ' + that.obj_data.U + '%0APassword : ' + that.obj_data.UP;
                            that.slideinDSummary = true;
                        }
                    });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_data"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            ValidationErrMsg(value, langKey = "") {
                var validateObj = this.$v.obj_data[value];

                if (this.bool_CV == true) {
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        return String.format(this.getLanguage["AG"]['ERR4'], this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.getLanguage["ERR"]['1009'], this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage["AG"][langKey]);
                    }
                }
            },
            copyDownlineLink(ElementId) {
                if (this.slideinSummary) {
                    var prefixCode = this.obj_Group.PC;
                    var username = this.obj_Group.Agent.U;
                    var password = this.obj_Group.Agent.UP;
                } else if (this.slideinDSummary) {
                    var prefixCode = this.obj_data.PC;
                    var username = this.obj_data.U;
                    var password = this.obj_data.UP;
                }

                var message = `${this.loginurl}?pc=${prefixCode}%26uid=${username}

PrefixCode : ${prefixCode}
Username : ${username}
Password : ${password}`;

                navigator.clipboard.writeText(message);

                //var input = document.getElementById(ElementId);
                //input.select();
                //document.execCommand("copy");
                //var tooltip = document.querySelector(".tooltip-modal");
                //tooltip.classList.add("show");
                //setTimeout(function () {
                //    tooltip.classList.remove("show");
                //}, 1000);


                this.$fire({
                    // type: 'error',
                    title: this.utilGetErrorLanguage("GL.COPY"),
                    html: this.utilGetErrorLanguage("GL.COPYD"),
                    width: '20em',
                    keydownListenerCapture: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    },
                    didOpen: () => {
                        const confirmButton = document.querySelector('.afb-alert-action button');
                        if (confirmButton) {
                            confirmButton.focus();
                        }
                    }
                })
            },
            changeNegativecolor(value) {
                if (value < 0) {
                    return {
                        color: 'rgb(229, 54, 54)',
                        display: 'block'
                    }
                }
                else if (value > 0) {
                    return {
                        color: 'rgb(48, 135, 142)',
                        display: 'block'
                    }
                }
                return { display: 'block' }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        validations: {
            obj_Group: {
                GN: { required },
                //AT: { required },
                //PGI: { required },
                //DCI: { required },
                //CA: { required },
                //CurrencyIds: { required },
                //Language: { required },
                SAGAGI: {
                    required: requiredIf(function (vm) {
                        if (!vm.PGIT) {
                            return false;
                        }
                        if (vm.PGIT.indexOf("-") > 0) {
                            var agi = vm.PGIT.split("-");

                            if (agi[0] == 4)
                                return true;
                            else
                                return false;
                        } else
                            return true;
                    })
                },
                PC: { required, minLength: minLength(8), maxLength: maxLength(8), alphaNum },
                Agent: {
                    U: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    UP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                        minLength: minLength(4)
                    },
                    E: { email },
                },
                SubAgentPayoutScheme: {
                    PT: {
                        required,
                        between: function (val, obj) {
                            let res = true;
                            if (val) {
                                if (val < this.selectedMinPT || val > this.selectedMaxPT) {
                                    res = false;
                                }
                            }
                            return res;
                        }
                    },
                    WLT: { required },
                    POT: { required },
                },
            },
            obj_data: {
                U: { required },
                RI: { required },
                ATAGI: { required },
                DN: { required },
                E: { email },
                ALOD: { required, numeric, minValueValue: minValue(0) },
                UP: {
                    //required: requiredIf(function (vm) {
                    //    return vm.I == 0;
                    //}),
                    required,
                    minLength: minLength(4)
                },
                CUP: {
                    //required: requiredIf(function (vm) {
                    //    return vm.I == 0;
                    //}),
                    required,
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'PL';
            this.$parent.showActiveMenu = 'PL.DPL';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            if (this.getUserInfo.AT == 4) {
                this.getCurrencyList();
                this.getAgentGroupDropdown()
                this.loadDefaultSubBrand(0);

                if (window.location.hostname == 'localhost') {
                    this.loginurl = window.location.hostname + ':13880/App/Login';
                }
                else {
                    this.loginurl = 'https://' + window.location.hostname + '/App/Login';
                }
            }
        },
        watch: {
            'obj_Group.GN': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        this.obj_Group.Agent.DN = val;

                    }
                }, deep: true
            },
            '$route.query': {
                handler(newQuery, oldQuery) {
                    this.dependUrlShowItem();
                },
                immediate: true // Trigger watcher immediately when the component is created
            }
        },
    }
</script>

<style>
    /*.negative-number span {
        color: #e55353 !important;
    }*/
</style>



// WEBPACK FOOTER //
// src/componentsGGEarn/SideMenu/GGearnDownline.vue